export const aboutText = `As you can tell my experience is a pretty mix... from development tools to safety cycles mindset and because the process is solving the complex and the abstract open ended. I love the autonomy to work on things and to explore areas. I'm a creative type and contrary to how that sounds, I get to employ that in my day to day by getting to develop solutions and stress-improving all the little things that add up to good code!

What I value the most at my job is being trusted to build out solutions or working with brilliant peers. Love when I contribute my one hand in any waves of experience and look forward to a (hopefully) long career in Software!`;

export const randomFacts = [
  "I have 4.3b experience in Runescape 3...",
  "My favorite game is Rimworld!",
  "One piece is the best anime!",
  "Yes I do go outside",
];
